let intervalId = null

/**
 * Progress Bar Animation
 *
 * @param {*} currentTab
 * @param {*} block
 * @return {void}
 */
const progressBarAnimation = ( currentTab, block ) => {


	if ( !currentTab ) {

		return

	}

	const progressBar = currentTab.querySelector( '.c-progress-bar__progress' )

	if ( !progressBar ) {

		return

	}

	const animationDuration = block.getAttribute( 'data-animation-duration' )
	const animationDurationMobile = block.getAttribute( 'data-animation-duration-mobile' )

	const startTime = performance.now()
	const mediaQuery = '(min-width: 992px)';
	const mediaQueryList = window.matchMedia( mediaQuery );

	/**
	 * Animate.
	 *
	 * @param {number} currentTime
	 */
	function animate ( currentTime ){

		const elapsed = currentTime - startTime;
		let progress = Math.min( elapsed / animationDuration, 1 ); // Limituj postęp do 1

		if ( mediaQueryList.matches ) {

			progressBar.style.transform = `scaleY(${progress})`

		} else {

			progress = Math.min( elapsed / animationDurationMobile, 1 )
			progressBar.style.transform = `scaleX(${progress})`

		}

		mediaQueryList.addEventListener( 'change', ( e ) => {

			if ( e.matches ) {

				progressBar.style.transform = `scaleY(${progress})`

			} else {

				progress = Math.min( elapsed / animationDurationMobile, 1 )
				progressBar.style.transform = `scaleX(${progress})`

			}

		} )

		if ( progress < 1 ) {

			requestAnimationFrame( animate );

		}

	}

	requestAnimationFrame( animate );

}

/**
 *
 * @param {mixed} block
 * @param {number} tabNumber
 */
function rotateTab ( block, tabNumber ){

	const tabs = block.querySelectorAll( '.c-tab' );
	const imageTabs = block.querySelectorAll( '.c-tabs__image figure' );
	const currentTab = tabNumber
	const mediaQuery = '(min-width: 992px)';
	const mediaQueryList = window.matchMedia( mediaQuery );

	if ( mediaQueryList.matches ) {

		tabs.forEach( ( tab ) => {

			const currentText = tab.querySelector( '.c-tab__text' )
			currentText.style.maxHeight = 0
			tab.classList.remove( 'c-tab--active' )
			tab.classList.add( 'c-tab--inactive' )

		} )

	} else {

		tabs.forEach( ( tab ) => {

			// const currentTabToScroll = ( currentTab + 1 ) % tabs.length
			tab.classList.remove( 'c-tab--active' )
			tab.classList.add( 'c-tab--inactive' )

		} )

	}

	mediaQueryList.addEventListener( 'change', ( e ) => {

		if ( e.matches ) {

			tabs.forEach( ( tab ) => {

				const currentText = tab.querySelector( '.c-tab__text' )
				currentText.style.maxHeight = 0
				tab.classList.remove( 'c-tab--active' )
				tab.classList.add( 'c-tab--inactive' )

			} )

		} else {

			tabs.forEach( ( tab ) => {

				const currentText = tab.querySelector( '.c-tab__text' )
				tab.classList.remove( 'c-tab--active' )
				tab.classList.add( 'c-tab--inactive' )
				currentText.style.maxHeight = 'unset'

			} )

		}

	} )


	tabs[ currentTab ].classList.remove( 'c-tab--inactive' )
	tabs[ currentTab ].classList.add( 'c-tab--active' )
	imageTabs.forEach( ( image ) => {

		image.classList.remove( 'image-visible' )

	} )
	if ( imageTabs[ currentTab ] ) {

		imageTabs[ currentTab ].classList.add( 'image-visible' )

	}

	if ( mediaQueryList.matches ) {

		const currentText = tabs[ currentTab ].querySelector( '.c-tab__text' )
		const currentTextHeight = currentText.scrollHeight

		currentText.style.maxHeight = `${currentTextHeight}px`

	}

	mediaQueryList.addEventListener( 'change', ( e ) => {

		if ( e.matches ) {

			const currentText = tabs[ currentTab ].querySelector( '.c-tab__text' )
			const currentTextHeight = currentText.scrollHeight

			currentText.style.maxHeight = `${currentTextHeight}px`

		}

	} )

	progressBarAnimation( tabs[ currentTab ], block )

}

/**
 *
 * @param {mixed} container
 * @param {any} target
 * @param {number} duration
 */
function smoothScroll ( container, target, duration ){

	const start = container.scrollLeft
	const change = target.offsetLeft - 32 - start
	let currentTime = 0
	const increment = 20

	/**
	 *
	 */
	const animateScroll = () => {

		currentTime += increment
		const val = Math.easeInOutQuad( currentTime, start, change, duration )
		container.scrollLeft = val
		if ( currentTime < duration ) {

			setTimeout( animateScroll, increment )

		}

	};
	animateScroll()

}

Math.easeInOutQuad = ( t, b, c, d ) => {

	t /= d / 2
	if ( t < 1 ) {

		return ( c / 2 * t * t ) + b

	}

	t--

	return ( ( -c / 2 ) * ( ( t * ( t - 2 ) ) - 1 ) ) + b

}

/**
 *
 * @param {object} block
 * @param {string} currentTab
 * @param {string} mediaQueryList
 * @param {string} container
 */
const rotateTabs = ( block, currentTab, mediaQueryList, container ) => {

	rotateTab( block, currentTab )

	if ( !mediaQueryList.matches ) {

		const activeTab = container.querySelector( '.c-tab--active' )

		smoothScroll( container, activeTab, 500 )

	}

	mediaQueryList.addEventListener( 'change', ( e ) => {

		if ( !e.matches ) {

			const activeTab = container.querySelector( '.c-tab--active' )

			smoothScroll( container, activeTab, 500 )

		} else {

		}

	} )

}

/**
 * Featrue Tabs Animation.
 *
 * @param {mixed} block
 */
const featureTabsAnimation = ( block ) => {


	if ( !block ) {

		return

	}
	const container = block.querySelector( '.c-tabs' )
	const imageContainer = block.querySelector( '.c-tabs__image' )
	const tabs = container.querySelectorAll( '.c-tab' )
	const imageTabs = imageContainer.querySelectorAll( 'figure' )
	const mediaQuery = '(min-width: 992px)'
	const mediaQueryList = window.matchMedia( mediaQuery )
	const animationDuration = block.getAttribute( 'data-animation-duration' )
	const animationDurationMobile = block.getAttribute( 'data-animation-duration-mobile' )

	let currentTab = 0;

	rotateTab( block, 0 )

	if ( mediaQueryList.matches ) {

		intervalId = setInterval( () => {

			currentTab = ( currentTab + 1 ) % tabs.length
			rotateTabs( block, currentTab, mediaQueryList, container );

		}, ( animationDuration ) ? animationDuration : '7000' );

		tabs.forEach( ( tab, index ) => {

			tab.addEventListener( 'click', () => {

				clearInterval( intervalId )
				container.classList.add( 'js-tabs-animation-stopped' )

				tabs.forEach( ( tabItem ) => {


					tabItem.classList.remove( 'c-tab--active' )
					tabItem.classList.add( 'c-tab--inactive' )


				} )
				imageTabs.forEach( ( image ) => {

					image.classList.remove( 'image-visible' )

				} )
				if ( imageTabs[ index ] ) {

					imageTabs[ index ].classList.add( 'image-visible' )

				}

				rotateTab( block, index )

				intervalId = setInterval( () => {

					if ( container.classList.contains( 'js-tabs-animation-stopped' ) ) {

						currentTab = ( index + 1 ) % tabs.length
						container.classList.remove( 'js-tabs-animation-stopped' )

					} else {

						currentTab = ( currentTab + 1 ) % tabs.length

					}

					rotateTab( block, currentTab )

				}, ( animationDuration ) ? animationDuration : '5000' )

			} )

		} )

		clearIntervalOnResize( mediaQueryList, intervalId )

	} else {

		intervalId = setInterval( () => {

			currentTab = ( currentTab + 1 ) % tabs.length
			rotateTabs( block, currentTab, mediaQueryList, container );

		}, ( animationDurationMobile ) ? animationDurationMobile : '15000' );

		clearIntervalOnResize( mediaQueryList, intervalId )

	}

	/**
	 *
	 * @param {string} mq
	 */
	function clearIntervalOnResize ( mq ){

		mq.addEventListener( 'change', ( e ) => {

			if ( e.matches ) {

				if ( intervalId ) {

					clearInterval( intervalId );

				}
				currentTab = 0
				let hasStoped = true
				intervalId = setInterval( () => {

					if ( hasStoped ) {

						currentTab = ( currentTab ) % tabs.length
						rotateTabs( block, currentTab, mediaQueryList, container )
						hasStoped = false

					} else {

						currentTab = ( currentTab + 1 ) % tabs.length
						rotateTabs( block, currentTab, mediaQueryList, container )

					}

				}, ( animationDuration ) ? animationDuration : '7000' );

				tabs.forEach( ( tab, index ) => {

					tab.addEventListener( 'click', () => {

						clearInterval( intervalId )
						container.classList.add( 'js-tabs-animation-stopped' )

						tabs.forEach( ( tabItem ) => {

							tabItem.classList.remove( 'c-tab--active' )
							tabItem.classList.add( 'c-tab--inactive' )

						} )

						rotateTab( block, index )

						intervalId = setInterval( () => {

							if ( container.classList.contains( 'js-tabs-animation-stopped' ) ) {

								currentTab = ( index + 1 ) % tabs.length
								container.classList.remove( 'js-tabs-animation-stopped' )

							} else {

								currentTab = ( currentTab + 1 ) % tabs.length

							}

							rotateTab( block, currentTab )

						}, ( animationDuration ) ? animationDuration : '5000' )

					} )

				} )

			} else {

				if ( intervalId ) {

					clearInterval( intervalId );

				}
				currentTab = 0

				intervalId = setInterval( () => {

					currentTab = ( currentTab + 1 ) % tabs.length
					rotateTabs( block, currentTab, mediaQueryList, container );

				}, ( animationDurationMobile ) ? animationDurationMobile : '15000' );

				clearIntervalOnResize( mediaQueryList, intervalId )

			}

		} )

	}

}

const observer = new IntersectionObserver( ( entries, obs ) => {

	entries.forEach( ( entry ) => {

		if ( entry.isIntersecting ) {

			featureTabsAnimation( entry.target )
			obs.unobserve( entry.target )

		}

	} );

} );

document.querySelectorAll( '.b-feature-tabs .js-feature-tabs' ).forEach( ( block ) => {

	observer.observe( block )

} )
